export const summaryRows: string[] = [
  "Volume 01 — Weather, Climate & Earth's Energy Balance: The Atmosphere and the Greenhouse Effect",
  'Volume 02 — The Climate System in Motion: Oceans, Ice, Atmospheric Circulation, Water & Carbon Cycles',
  "Volume 03 — Reading Earth's Climate History: Paleoclimate, Ice Cores & Natural Climate Change",
  'Volume 04 — Modern Climate Change: Evidence, Causes, Measurement & Climate Models',
  'Volume 05 — Impacts of Climate Change: Oceans, Ice, Extreme Weather, Ecosystems & People',
  'Volume 06 — Responding to Climate Change: Mitigation, Adaptation, Policy & Teaching Climate with Confidence',
  'Bonus 1 — Hands-On Climate Science Classroom Experiments & Demos',
  'Bonus 2 — Climate Data & Graph-Reading Worksheets with Answer Keys',
  'Bonus 3 — Illustrated Climate Science Glossary & Vocabulary Cards',
  'Bonus 4 — Climate Science Quick-Reference Charts & Diagram Pack',
  'Bonus 5 — Climate Myths vs Evidence: Classroom Discussion Cards',
  '7-day money-back guarantee',
  'Instant access',
];
